import React, { useState, useEffect } from 'react'
import { Col, Container, Row, Card, Table, Badge, Spinner, Modal, Button, Form, Alert } from 'react-bootstrap'
import Header from '../../layouts/Header'
import { useSelector } from 'react-redux';
import { PackageSearch, Calendar, FileText, Store, User, Edit, X } from 'lucide-react';
import axiosInstance from '../../api/axios';import { Download, Eye, Trash2 } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import Select from 'react-select';
import DatePicker from "react-datepicker";

const LocalProcurement = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access, email } = useSelector((state) => state.login);
    const [localProcurementAccess, setLocalProcurementAccess] = useState([]);
    const [procurements, setProcurements] = useState([]);
    const [procurementItemsList, setProcurementItemsList] = useState([]);
    const [loading, setLoading] = useState(false); // Changed to false initially
    const [itemsLoading, setItemsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [show, setShow] = useState(false);

    //Filters
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [currentPage, setCurrentPage] = useState('1');
    const [recordsPerPage, setRecordsPerPage] = useState('25');
    const [filterError, setFilterError] = useState('');
    const [btnLoading, setBtnLoading] = useState(false);
    const [isClicked, setIsClicked] = useState(false);

    // Editable procurements items states
    const [editingRow, setEditingRow] = useState(null);
    const [editQuantity, setEditQuantity] = useState("");
    const [editRate, setEditRate] = useState("");
    const [localProcurementId, setLocalProcurementId] = useState('');
    const [isEditItemBtnLoading, setIsEditItemBtnLoading] = useState(false);
    const [openItemDeleteModal, setOpenItemDeleteModal] = useState(false);
    const [itemId, setItemId] = useState('');
    const [isDeleteItemLoading, setIsDeleteItemLoading] = useState(false);

    // Update Procurement states
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [selectedProcurementForUpdate, setSelectedProcurementForUpdate] = useState(null);
    const [updateFormData, setUpdateFormData] = useState({
        _id: '',
        outlet: '',
        vendor: '',
        invoiceNo: '',
        invoice_file: null
    });
    const [updateLoading, setUpdateLoading] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [filePreview, setFilePreview] = useState(null);
    const [updateErrors, setUpdateErrors] = useState({});

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("LocalProcurement:")
            );
            setLocalProcurementAccess(filteredAccess);
        }
    }, [access]);

    const accessToken = localStorage.getItem('authToken');
    const [procurementId, setProcurementId] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);

    // New state for items modal
    const [showItemsModal, setShowItemsModal] = useState(false);
    const [selectedProcurement, setSelectedProcurement] = useState(null);

    // Fetch outlets on component mount
    const fetchOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const outletsResponse = await axiosInstance.get('outlet', { headers });
            console.log("Outlets Response:", outletsResponse);
            setOutlets(outletsResponse.data?.data?.outlets || []);
        } catch (error) {
            console.error('Error fetching outlets:', error);
            toast.error('Failed to load outlets', {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    const getLocalProcrements = async (outlet, start, end) => {
        // Don't fetch if no outlet is selected
        if (!outlet) {
            setProcurements([]);
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            // Build query parameters
            let queryParams = `outlet=${outlet}`;
            if (start) {
                queryParams += `&startDate=${start.toISOString().split("T")[0]}`;
            }
            if (end) {
                queryParams += `&endDate=${end.toISOString().split("T")[0]}`;
            }

            // const response = await axiosInstance.get(`local-procurement?${queryParams}`, { headers });
            // console.log("Response:", response);
            // setProcurements(response.data.data.dbResponse || []);
            // toast.success(response?.data?.data?.message, {
            //     position: "top-right",
            //     autoClose: 3000,
            //     theme: "light",
            // });
            const response = await axiosInstance.get(`local-procurement?${queryParams}`, { headers });
            const newData = response?.data?.data?.dbResponse || [];

            // Sort API data by createdAt descending (optional but clean)
            newData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

            // Find newest createdAt timestamp already in state
            const latestExistingDate = procurements.length > 0
                ? Math.max(...procurements.map(item => new Date(item.createdAt).getTime()))
                : null;

            // Filter entries that are newer than the latest existing one
            let newEntries = [];
            if (latestExistingDate) {
                newEntries = newData.filter(
                    item => new Date(item.createdAt).getTime() > latestExistingDate
                );
            } else {
                // First load: no previous data
                newEntries = newData;
            }

            // Update state
            setProcurements(newData);

            // Show toast only for new entries
            if (newEntries.length > 0) {
                toast.success(`${newEntries.length} new procurement record(s) added`, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }

        } catch (error) {
            console.log("Error:", error);
            // setError("Failed to fetch procurement data");
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 404) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 400) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                } else {
                    errorMessage = "Something went wrong. Please try again.";
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
            setShow(true);
            setProcurements([]);
        } finally {
            setLoading(false);
            setBtnLoading(false);
        }
    }

    const getLocalProcrementsItems = async (itemId) => {
        try {
            setItemsLoading(true);
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axiosInstance.get(`local-procurement-item?localProcurementId=${itemId}`, { headers });
            console.log("Response of Items:", response?.data?.data?.dbResponse);
            setProcurementItemsList(response?.data?.data?.dbResponse || []);
            return response?.data?.data?.dbResponse || [];
        } catch (error) {
            console.log("Error:", error);
            toast.error("Failed to fetch procurement items", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
            return [];
        } finally {
            setItemsLoading(false);
        }
    }

    // Fetch vendors and outlets for dropdowns
    const fetchDropdownData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            // Fetch vendors
            const vendorsResponse = await axiosInstance.get('vendor', { headers });
            console.log("Vendors Response:", vendorsResponse);
            setVendors(vendorsResponse.data?.data?.vendors || []);

            // Fetch outlets if not already loaded
            if (outlets.length === 0) {
                const outletsResponse = await axiosInstance.get('outlet', { headers });
                console.log("Outlets Response:", outletsResponse);
                setOutlets(outletsResponse.data?.data?.outlets || []);
            }
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
            toast.error('Failed to load dropdown data', {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    const handleView = async (procurement) => {
        console.log("View Data :", procurement);
        setShowItemsModal(true);
        setItemsLoading(true);
        setProcurementId(procurement?._id);
        setSelectedProcurement(procurement);
        setLocalProcurementId(procurement?._id);
        const items = await getLocalProcrementsItems(procurement?._id);
        setProcurementItemsList(items);
    }

    const handleUpdate = async (procurement) => {
        console.log("Update Data:", procurement);
        setSelectedProcurementForUpdate(procurement);

        // Initialize form data
        setUpdateFormData({
            _id: procurement._id || '',
            outlet: procurement.outlet?._id || '',
            vendor: procurement.vendor?._id || '',
            invoiceNo: procurement.invoiceNo || '',
            invoice_file: null
        });
        setFilePreview(procurement.invoice_file || null);
        setUpdateErrors({});

        // Fetch dropdown data and show modal
        await fetchDropdownData();
        setShowUpdateModal(true);
    }

    const handleCloseUpdateModal = () => {
        setShowUpdateModal(false);
        setSelectedProcurementForUpdate(null);
        setUpdateFormData({
            _id: '',
            outlet: '',
            vendor: '',
            invoiceNo: '',
            invoice_file: null
        });
        setFilePreview(null);
        setUpdateErrors({});
    }

    const handleUpdateInputChange = (e) => {
        const { name, value } = e.target;
        setUpdateFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user starts typing
        if (updateErrors[name]) {
            setUpdateErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleUpdateFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file type
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
            if (!allowedTypes.includes(file.type)) {
                setUpdateErrors(prev => ({
                    ...prev,
                    invoice_file: 'Please select a valid file (JPEG, PNG, JPG, PDF)'
                }));
                return;
            }

            // Validate file size (5MB limit)
            if (file.size > 5 * 1024 * 1024) {
                setUpdateErrors(prev => ({
                    ...prev,
                    invoice_file: 'File size should be less than 5MB'
                }));
                return;
            }

            setUpdateFormData(prev => ({
                ...prev,
                invoice_file: file
            }));

            // Create preview for images
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    setFilePreview(e.target.result);
                };
                reader.readAsDataURL(file);
            } else {
                setFilePreview(null);
            }

            // Clear file error
            if (updateErrors.invoice_file) {
                setUpdateErrors(prev => ({
                    ...prev,
                    invoice_file: ''
                }));
            }
        }
    };

    const removeUpdateFile = () => {
        setUpdateFormData(prev => ({
            ...prev,
            invoice_file: null
        }));
        setFilePreview(null);
    };

    const validateUpdateForm = () => {
        const newErrors = {};

        if (!updateFormData.outlet.trim()) {
            newErrors.outlet = 'Outlet is required';
        }

        if (!updateFormData.vendor.trim()) {
            newErrors.vendor = 'Vendor is required';
        }

        if (!updateFormData.invoiceNo.trim()) {
            newErrors.invoiceNo = 'Invoice number is required';
        }

        setUpdateErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        if (!validateUpdateForm()) {
            return;
        }

        setUpdateLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            };

            const submitData = new FormData();
            submitData.append('_id', updateFormData._id);
            submitData.append('outlet', updateFormData.outlet);
            submitData.append('vendor', updateFormData.vendor);
            submitData.append('invoiceNo', updateFormData.invoiceNo);

            if (updateFormData.invoice_file) {
                submitData.append('invoice_file', updateFormData.invoice_file);
            }

            const response = await axiosInstance.put('/local-procurement', submitData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message || 'Procurement updated successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });

                // Refresh the procurement list
                getLocalProcrements(selectedOutlet, startDate, endDate);
                handleCloseUpdateModal();
            }
        } catch (error) {
            console.error('Update error:', error);
            let errorMessage = 'Failed to update procurement';

            if (error.response && error.response?.data?.error) {
                errorMessage = error.response.data.error;
            } else if (error.response && error.response?.data?.message) {
                errorMessage = error.response.data.message;
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setUpdateLoading(false);
        }
    };

    const handleCloseItemsModal = () => {
        setShowItemsModal(false);
        setSelectedProcurement(null);
        setProcurementItemsList([]);
    }

    const handleDelete = (data) => {
        console.log("Delete Modal Data :", data);
        setProcurementId(data?._id);
        setOpenDeleteModal(true);
    }

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
        setProcurementId('')
    }

    const handleSubmitDelete = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: procurementId,
            };

            const response = await axiosInstance.delete(`local-procurement`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getLocalProcrements(selectedOutlet, startDate, endDate);
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsDeleteLoading(false);
        }
    }

    // Editable procurements items Functions
    const startEditing = (item) => {
        setEditingRow(item._id);
        setEditQuantity(item.quantity);
        setEditRate(item.rate);
    };

    const cancelEditing = () => {
        setEditingRow(null);
        setEditQuantity("");
        setEditRate("");
    };

    const saveEditing = async (item) => {
        setIsEditItemBtnLoading(true);
        try {
            const updatedItem = {
                _id: item._id,
                localProcurementId: item.localProcurementId,
                rawMaterial: item.rawMaterial?._id, // extract only the ID
                quantity: parseFloat(editQuantity),
                rate: parseFloat(editRate),
            }
            console.log("Updated Items :", updatedItem);

            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            const response = await axiosInstance.put('local-procurement-item', updatedItem, { headers });
            if (response?.data?.status === true) {
                console.log("Response of updating item :", response);
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getLocalProcrementsItems(localProcurementId);
            }
        } catch (error) {
            console.log("Error :", error);

        } finally {
            setIsEditItemBtnLoading(false);
        }

        setEditingRow(null);
    };

    const handleItemDelete = async (item) => {
        setOpenItemDeleteModal(true);
        console.log("Item Data :", item);
        setItemId(item);
    }

    const handleCloseItemDeleteModal = () => {
        setOpenItemDeleteModal(false);
        setItemId('');
    }

    const handleSubmitItemDelete = async (e) => {
        e.preventDefault();
        setIsDeleteItemLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: itemId,
            };

            const response = await axiosInstance.delete(`local-procurement-item`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getLocalProcrementsItems(procurementId);
                setOpenItemDeleteModal(false);
                setItemId('')
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsDeleteItemLoading(false);
        }
    }

    const handleEndDateChange = (date) => {
        if (date && startDate && date < startDate) {
            setFilterError('End date cannot be earlier than start date');
        } else {
            setFilterError('');
            setEndDate(date);
        }
    };

    const handleSubmitFilters = async (e) => {
        e.preventDefault();
        setBtnLoading(true);
        setIsClicked(true);
        if (!selectedOutlet) {
            toast.error("Please select an outlet first", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
            setBtnLoading(false);
            return;
        }

        setCurrentPage(1);

        const adjustedStartDate = startDate ? new Date(startDate.setHours(23, 59, 59, 999)) : null;
        const adjustedEndDate = endDate ? new Date(endDate.setHours(23, 59, 59, 999)) : null;

        await getLocalProcrements(selectedOutlet, adjustedStartDate, adjustedEndDate);


    }

    // Handle outlet change - only update state, don't fetch data
    const handleOutletChange = (e) => {
        const outletId = e.target.value;
        setSelectedOutlet(outletId);
    }

    const handleDownloadInvoice = (procurement) => {
        const url = procurement?.invoice_file;
        if (!url) return;

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "invoice"); // optional – browser will preserve original filename
        document.body.appendChild(link);
        link.click();
        link.remove();
    };


    // Fetch outlets on component mount
    useEffect(() => {
        fetchOutlets();
    }, []);

    // Format date to readable format
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    // Format currency
    const formatCurrency = (amount) => {
        if (!amount) return '₹0.00';

        // Handle both regular numbers and MongoDB Decimal128 objects
        const numAmount = typeof amount === 'object' && amount.$numberDecimal
            ? parseFloat(amount.$numberDecimal)
            : parseFloat(amount);

        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2
        }).format(numAmount);
    }

    if (loading && outlets.length === 0) {
        return (
            <React.Fragment>
                <Header onSkin={setSkin} />
                <div className={`main main-app p-3 p-lg-3 ${skin === 'dark' ? 'bg-dark text-white' : 'bg-light'}`}>
                    <Container fluid>
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                            <div className="text-center">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2">Loading outlets...</p>
                            </div>
                        </div>
                    </Container>
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-3 ${skin === 'dark' ? 'bg-dark text-white' : 'bg-light'}`}>
                <Container fluid>
                    <Card className={`shadow-sm ${skin === 'dark' ? 'bg-dark text-white' : ''}`}>
                        <Card.Body>
                            <Row className="mb-1">
                                <Col>
                                    <h5 className="fw-semibold mb-2">
                                        <PackageSearch size={22} className="me-2" />
                                        LOCAL PROCUREMENT
                                        <Badge bg="primary" className="ms-2">
                                            {procurements.length} Records
                                        </Badge>
                                    </h5>
                                    {/* <p className="text-muted mb-0">
                                        Please select an outlet and click "Get Procurements" to view records
                                    </p> */}
                                </Col>
                                <hr />
                            </Row>

                            <div className="mb-4 p-3 bg-light rounded-3">
                                <Form onSubmit={handleSubmitFilters}>
                                    <Row className="g-3">
                                        <Col md={3}>
                                            <Form.Group controlId="outletSelect">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-shop me-2"></i>Outlet <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    value={selectedOutlet}
                                                    onChange={handleOutletChange}
                                                    className={skin === 'dark' ? 'bg-dark text-light border-secondary' : ''}
                                                    required
                                                >
                                                    <option value="">Select Outlet</option>
                                                    {outlets?.map((outlet) => (
                                                        <option key={outlet._id} value={outlet._id}>
                                                            {outlet.name} ({outlet.city})
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Text className="text-muted">
                                                    Select an outlet to view procurement records
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col md={2}>
                                            <Form.Group controlId="startDate">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-calendar me-2"></i>Start Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setStartDate(date);
                                                        // Reset end date if it goes beyond new range
                                                        if (endDate && date && endDate > new Date(date.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                                            setEndDate(null);
                                                        }
                                                    }}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Start Date"
                                                    className={`form-control ${skin === 'dark' ? 'bg-dark text-light border-secondary' : ''}`}
                                                    disabled={!selectedOutlet}
                                                    onKeyDown={(e) => e.preventDefault()}    // ⛔ stop typing
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={2}>
                                            <Form.Group controlId="endDate">
                                                <Form.Label className="fw-semibold">
                                                    <i className="bi bi-calendar me-2"></i>End Date
                                                </Form.Label>
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={handleEndDateChange}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="End Date"
                                                    className={`form-control ${skin === 'dark' ? 'bg-dark text-light border-secondary' : ''}`}
                                                    minDate={startDate}
                                                    disabled={!selectedOutlet}
                                                    onKeyDown={(e) => e.preventDefault()}    // ⛔ stop typing
                                                />
                                                {filterError && <div className="text-danger small mt-1">{filterError}</div>}
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Label className="text-white">
                                                .
                                            </Form.Label>
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                className="w-100"
                                                disabled={!selectedOutlet || btnLoading}
                                            >
                                                {btnLoading ? (
                                                    <Spinner as="span" animation="border" size="sm" />
                                                ) : (
                                                    "Get Procurements"
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>

                            {/* Show message when no outlet is selected or data hasn't been loaded yet */}
                            {procurements?.length === 0 && !show && (
                                <div className="text-center py-5">
                                    <Store size={48} className="text-muted mb-3" />
                                    <h5>Select an Outlet</h5>
                                    <p className="text-muted">Please select an outlet from the dropdown above and click "Get Procurements" to view records.</p>
                                </div>
                            )}

                            {/* Show message when outlet is selected but no data has been loaded */}
                            {/* {selectedOutlet && procurements.length === 0 && !loading && (
                                <div className="text-center py-5">
                                    <PackageSearch size={48} className="text-muted mb-3" />
                                    <h5>Ready to Load Data</h5>
                                    <p className="text-muted">Outlet selected. Click "Get Procurements" to load the procurement records.</p>
                                </div>
                            )} */}

                            {/* Summary Cards - Only show when outlet is selected and data exists */}
                            {procurements.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className={`text-center ${skin === 'dark' ? 'bg-secondary' : 'bg-light'}`}>
                                            <Card.Body>
                                                <h6 className="card-title">Total Transactions</h6>
                                                <h4 className="text-primary">{procurements.length}</h4>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className={`text-center ${skin === 'dark' ? 'bg-secondary' : 'bg-light'}`}>
                                            <Card.Body>
                                                <h6 className="card-title">Total Amount</h6>
                                                <h4 className="text-success">
                                                    {formatCurrency(procurements.reduce((sum, item) => sum + item.grandTotal, 0))}
                                                </h4>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className={`text-center ${skin === 'dark' ? 'bg-secondary' : 'bg-light'}`}>
                                            <Card.Body>
                                                <h6 className="card-title">Total Taxable</h6>
                                                <h4 className="text-info">
                                                    {formatCurrency(procurements.reduce((sum, item) => sum + item.totalTaxable, 0))}
                                                </h4>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className={`text-center ${skin === 'dark' ? 'bg-secondary' : 'bg-light'}`}>
                                            <Card.Body>
                                                <h6 className="card-title">Total Tax</h6>
                                                <h4 className="text-warning">
                                                    {formatCurrency(procurements.reduce((sum, item) => sum + item.totalTaxAmount, 0))}
                                                </h4>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Show loading when fetching data */}
                            {selectedOutlet && loading && (
                                <div className="text-center py-4">
                                    <Spinner animation="border" variant="primary" />
                                    <p className="mt-2">Loading procurement data...</p>
                                </div>
                            )}

                            {/* Show empty state when outlet is selected but no data after loading */}
                            {!loading && procurements.length === 0 && btnLoading === false && isClicked && (
                                <div className="text-center py-5">
                                    <PackageSearch size={48} className="text-muted mb-3" />
                                    <h5>No Procurement Records Found</h5>
                                    <p className="text-muted">No local procurement data available for the selected outlet and filters.</p>
                                </div>
                            )}

                            {/* Show table when outlet is selected and data exists */}
                            {!loading && procurements?.length > 0 && (
                                <div className="table-responsive pt-3">
                                    <Table striped bordered hover variant={skin === 'dark' ? 'dark' : ''}>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Invoice Details</th>
                                                <th>Vendor</th>
                                                <th>Outlet</th>
                                                <th>Taxable Amount</th>
                                                <th>Tax Amount</th>
                                                <th>Grand Total</th>
                                                {/* <th>Status</th> */}
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {procurements.map((procurement) => (
                                                <tr key={procurement._id}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <Calendar size={14} className="me-1" />
                                                            <small>
                                                                {formatDate(procurement.createdAt)}
                                                            </small>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <FileText size={16} className="me-2" />
                                                            <div>
                                                                <strong>{procurement.invoiceNo}</strong>
                                                                {!procurement.invoice_file && (
                                                                    <div>
                                                                        <small className="text-muted">No file attached</small>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <User size={16} className="me-2" />
                                                            <div>
                                                                <div>{procurement.vendor?.name}</div>
                                                                <small className="text-muted">
                                                                    GST: {procurement.vendor?.gstin}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <Store size={16} className="me-2" />
                                                            <div>
                                                                <div style={{ fontSize: '13px' }}>{procurement.outlet?.name || 'N/A'}</div>
                                                                <small className="text-muted">
                                                                    {procurement.outlet?.city}, {procurement.outlet?.state}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="text-end">
                                                        {formatCurrency(procurement.totalTaxable)}
                                                    </td>
                                                    <td className="text-end">
                                                        {formatCurrency(procurement.totalTaxAmount)}
                                                    </td>
                                                    <td className="text-end fw-bold">
                                                        {formatCurrency(procurement.grandTotal)}
                                                    </td>
                                                    
                                                    {/* <td>
                                                        <Badge
                                                            bg={
                                                                procurement.grandTotal > 0 ? 'success' :
                                                                    'warning'
                                                            }
                                                        >
                                                            {procurement.grandTotal > 0 ? 'Completed' : 'Pending'}
                                                        </Badge>
                                                    </td> */}
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                Actions
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => handleView(procurement)}
                                                                    >
                                                                        <Eye size={14} className="me-2" />
                                                                        View Details
                                                                    </button>
                                                                </li>
                                                                {/* <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => handleUpdate(procurement)}
                                                                    >
                                                                        <Edit size={14} className="me-2" />
                                                                        Update
                                                                    </button>
                                                                </li> */}
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => handleDownloadInvoice(procurement)}
                                                                    >
                                                                        <Download size={14} className="me-2" />
                                                                        Get Invoice
                                                                    </button>
                                                                </li>
                                                                {/* <li><hr className="dropdown-divider" /></li>
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item text-danger"
                                                                        onClick={() => handleDelete(procurement)}
                                                                    >
                                                                        <Trash2 size={14} className="me-2" />
                                                                        Delete
                                                                    </button>
                                                                </li> */}
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                        </Card.Body>
                    </Card>

                    {/* Procurement Items Modal */}
                    <Modal
                        show={showItemsModal}
                        onHide={handleCloseItemsModal}
                        centered
                        size="xl"
                        className={skin === 'dark' ? 'dark-modal' : ''}
                    >
                        <Modal.Header closeButton className={skin === 'dark' ? 'bg-dark text-white border-secondary' : ''}>
                            <Modal.Title>
                                <PackageSearch size={20} className="me-2" />
                                Procurement Items - {selectedProcurement?.invoiceNo}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className={skin === 'dark' ? 'bg-dark text-white' : ''}>
                            {itemsLoading ? (
                                <div className="text-center py-4">
                                    <Spinner animation="border" variant="primary" />
                                    <p className="mt-2 mb-0">Loading items...</p>
                                </div>
                            ) : procurementItemsList.length === 0 ? (
                                <div className="text-center py-4">
                                    <PackageSearch size={48} className="text-muted mb-3" />
                                    <h5>No Items Found</h5>
                                    <p className="text-muted">No items available for this procurement.</p>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <Table striped bordered hover variant={skin === 'dark' ? 'dark' : ''}>
                                        <thead>
                                            <tr>
                                                <th>Item Name</th>
                                                <th>HSN Code</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Taxable Amount</th>
                                                <th>Tax %</th>
                                                <th>Tax Amount</th>
                                                <th>Total</th>
                                                {/* <th>Actions</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {procurementItemsList.map((item, index) => (
                                                <tr key={item._id || index}>
                                                    <td>
                                                        <div>
                                                            <strong>{item.rawMaterial?.name}</strong>
                                                            {item.rawMaterial?.description && (
                                                                <small className="d-block text-muted">
                                                                    {item.rawMaterial.description.length > 50
                                                                        ? `${item.rawMaterial.description.substring(0, 50)}...`
                                                                        : item.rawMaterial.description
                                                                    }
                                                                </small>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>{item.rawMaterial?.hsn || 'N/A'}</td>
                                                    <td className="text-end" style={{ width: editingRow === item._id ? '100px' : '' }}>
                                                        {editingRow === item._id ? (
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                className="form-control form-control-sm text-end"
                                                                style={{ justifySelf: 'end', display: 'flex' }}
                                                                value={editQuantity}
                                                                onChange={(e) => setEditQuantity(e.target.value)}
                                                            />
                                                        ) : (
                                                            <>
                                                                {item.quantity} {item.rawMaterial?.unit}
                                                            </>
                                                        )}
                                                    </td>

                                                    <td className="text-end" style={{ width: editingRow === item._id ? '100px' : '' }}>
                                                        {editingRow === item._id ? (
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm text-end"
                                                                value={editRate}
                                                                style={{ justifySelf: 'end', display: 'flex' }}
                                                                onChange={(e) => setEditRate(e.target.value)}
                                                            />
                                                        ) : (
                                                            formatCurrency(item.rate)
                                                        )}
                                                    </td>

                                                    <td className="text-end">{formatCurrency(item.taxable)}</td>
                                                    <td className="text-end">{item.taxPercent}%</td>
                                                    <td className="text-end">{formatCurrency(item.taxAmount)}</td>
                                                    <td className="text-end fw-bold">{formatCurrency(item.grandTotal)}</td>
                                                    {/* <td className="fw-bold text-center" style={{ width: editingRow === item._id ? '200px' : '' }}>
                                                        {editingRow === item._id ? (
                                                            <>
                                                                <Button
                                                                    variant="success"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => saveEditing(item)}
                                                                >
                                                                    {
                                                                        isEditItemBtnLoading ? (
                                                                            <Spinner size="sm" />
                                                                        ) : (
                                                                            <>
                                                                                <i className="bi bi-check-circle me-1"></i>
                                                                                Save
                                                                            </>
                                                                        )
                                                                    }
                                                                </Button>

                                                                <Button
                                                                    variant="secondary"
                                                                    size="sm"
                                                                    onClick={cancelEditing}
                                                                >
                                                                    <i className="bi bi-x-circle me-1"></i> Cancel
                                                                </Button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Button
                                                                    variant="outline-primary"
                                                                    size="sm"
                                                                    className="me-2"
                                                                    onClick={() => startEditing(item)}
                                                                >
                                                                    <i className="bi bi-pencil-square me-1"></i> Update
                                                                </Button>

                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => handleItemDelete(item._id)}
                                                                >
                                                                    <i className="bi bi-trash me-1"></i> Delete
                                                                </Button>
                                                            </>
                                                        )}
                                                    </td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="fw-bold">
                                                <td colSpan="4" className="text-end">Total:</td>
                                                <td className="text-end">
                                                    {formatCurrency(procurementItemsList.reduce((sum, item) => sum + (item.taxable || 0), 0))}
                                                </td>
                                                <td></td>
                                                <td className="text-end">
                                                    {formatCurrency(procurementItemsList.reduce((sum, item) => sum + (item.taxAmount || 0), 0))}
                                                </td>
                                                <td className="text-end">
                                                    {formatCurrency(procurementItemsList.reduce((sum, item) => sum + (item.grandTotal || 0), 0))}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </Table>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer className={skin === 'dark' ? 'bg-dark border-secondary' : ''}>
                            <Button variant="secondary" onClick={handleCloseItemsModal}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Update Procurement Modal */}
                    <Modal
                        show={showUpdateModal}
                        onHide={handleCloseUpdateModal}
                        centered
                        size="lg"
                        className={skin === 'dark' ? 'dark-modal' : ''}
                    >
                        <Modal.Header closeButton className={skin === 'dark' ? 'bg-dark text-white border-secondary' : ''}>
                            <Modal.Title>
                                <i className="bi bi-pencil-square me-2"></i>
                                Update Local Procurement
                            </Modal.Title>
                        </Modal.Header>

                        <Form onSubmit={handleUpdateSubmit}>
                            <Modal.Body className={skin === 'dark' ? 'bg-dark text-white' : ''}>
                                {selectedProcurementForUpdate && (
                                    <div className="mb-3 p-3 bg-light rounded">
                                        <small className="text-muted">
                                            Updating: <strong>{selectedProcurementForUpdate.invoiceNo}</strong> •
                                            Created: {new Date(selectedProcurementForUpdate.createdAt).toLocaleDateString()}
                                        </small>
                                    </div>
                                )}

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Outlet <span className="text-danger">*</span></Form.Label>
                                            <Select
                                                name="outlet"
                                                value={outlets.find(outlet => outlet._id === updateFormData.outlet) ?
                                                    {
                                                        value: updateFormData.outlet,
                                                        label: `${outlets.find(outlet => outlet._id === updateFormData.outlet)?.name} - ${outlets.find(outlet => outlet._id === updateFormData.outlet)?.city}`
                                                    }
                                                    : null
                                                }
                                                onChange={(selectedOption) => {
                                                    handleUpdateInputChange({
                                                        target: {
                                                            name: 'outlet',
                                                            value: selectedOption ? selectedOption.value : ''
                                                        }
                                                    });
                                                }}
                                                options={outlets.map(outlet => ({
                                                    value: outlet._id,
                                                    label: `${outlet.name} - ${outlet.city}`
                                                }))}
                                                isClearable
                                                isSearchable
                                                placeholder="Select Outlet"
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: skin === 'dark' ? '#343a40' : '#fff',
                                                        borderColor: state.isFocused ? '#86b7fe' : updateErrors.outlet ? '#dc3545' : '#ced4da',
                                                        color: skin === 'dark' ? '#fff' : '#212529',
                                                        borderWidth: '1px',
                                                        borderRadius: '0.375rem',
                                                        minHeight: '38px',
                                                        transition: 'all 0.15s ease-in-out',
                                                        boxShadow: state.isFocused ?
                                                            (updateErrors.outlet ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : '0 0 0 0.2rem rgba(13, 110, 253, 0.25)')
                                                            : 'none',
                                                        '&:hover': {
                                                            borderColor: state.isFocused ? '#86b7fe' : updateErrors.outlet ? '#dc3545' : '#adb5bd'
                                                        },
                                                        fontFamily: 'inherit',
                                                        fontWeight: '400'
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        backgroundColor: skin === 'dark' ? '#343a40' : '#fff',
                                                        borderRadius: '0.375rem',
                                                        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                                                        border: skin === 'dark' ? '1px solid #495057' : '1px solid #dee2e6',
                                                        marginTop: '2px',
                                                        zIndex: 9999
                                                    }),
                                                    menuList: (base) => ({
                                                        ...base,
                                                        padding: '0',
                                                        borderRadius: '0.375rem'
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.isSelected
                                                            ? (skin === 'dark' ? '#0d6efd' : '#0d6efd')
                                                            : state.isFocused
                                                                ? (skin === 'dark' ? '#495057' : '#f8f9fa')
                                                                : (skin === 'dark' ? '#343a40' : '#fff'),
                                                        color: state.isSelected ? '#fff' : (skin === 'dark' ? '#fff' : '#212529'),
                                                        padding: '8px 12px',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.15s ease-in-out',
                                                        '&:active': {
                                                            backgroundColor: skin === 'dark' ? '#495057' : '#e9ecef'
                                                        }
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#fff' : '#212529',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400',
                                                        marginLeft: '2px'
                                                    }),
                                                    input: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#fff' : '#212529',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400'
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400'
                                                    }),
                                                    clearIndicator: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        padding: '4px',
                                                        cursor: 'pointer',
                                                        '&:hover': {
                                                            color: skin === 'dark' ? '#fff' : '#212529'
                                                        }
                                                    }),
                                                    dropdownIndicator: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        padding: '4px',
                                                        cursor: 'pointer',
                                                        '&:hover': {
                                                            color: skin === 'dark' ? '#fff' : '#212529'
                                                        }
                                                    }),
                                                    indicatorSeparator: (base) => ({
                                                        ...base,
                                                        backgroundColor: skin === 'dark' ? '#495057' : '#dee2e6'
                                                    }),
                                                    loadingIndicator: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d'
                                                    }),
                                                    noOptionsMessage: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400'
                                                    }),
                                                    loadingMessage: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400'
                                                    })
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: '#0d6efd',
                                                        primary25: skin === 'dark' ? '#495057' : '#e9ecef',
                                                        primary50: skin === 'dark' ? '#3d4348' : '#dee2e6',
                                                        primary75: '#0d6efd',
                                                        danger: '#dc3545',
                                                        dangerLight: '#f8d7da',
                                                        neutral0: skin === 'dark' ? '#343a40' : '#fff',
                                                        neutral5: skin === 'dark' ? '#495057' : '#f8f9fa',
                                                        neutral10: skin === 'dark' ? '#495057' : '#e9ecef',
                                                        neutral20: skin === 'dark' ? '#495057' : '#dee2e6',
                                                        neutral30: skin === 'dark' ? '#6c757d' : '#ced4da',
                                                        neutral40: skin === 'dark' ? '#6c757d' : '#adb5bd',
                                                        neutral50: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        neutral60: skin === 'dark' ? '#adb5bd' : '#495057',
                                                        neutral70: skin === 'dark' ? '#adb5bd' : '#495057',
                                                        neutral80: skin === 'dark' ? '#fff' : '#212529',
                                                        neutral90: skin === 'dark' ? '#fff' : '#212529',
                                                    },
                                                })}
                                            />
                                            {updateErrors.outlet && (
                                                <div className="text-danger small mt-1" style={{ fontSize: '0.875rem', fontWeight: '400' }}>
                                                    {updateErrors.outlet}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Vendor <span className="text-danger">*</span></Form.Label>
                                            <Select
                                                name="vendor"
                                                value={vendors.find(vendor => vendor._id === updateFormData.vendor) ?
                                                    {
                                                        value: updateFormData.vendor,
                                                        label: `${vendors.find(vendor => vendor._id === updateFormData.vendor)?.name} - ${vendors.find(vendor => vendor._id === updateFormData.vendor)?.gstin}`
                                                    }
                                                    : null
                                                }
                                                onChange={(selectedOption) => {
                                                    handleUpdateInputChange({
                                                        target: {
                                                            name: 'vendor',
                                                            value: selectedOption ? selectedOption.value : ''
                                                        }
                                                    });
                                                }}
                                                options={vendors.map(vendor => ({
                                                    value: vendor._id,
                                                    label: `${vendor.name} - ${vendor.gstin}`
                                                }))}
                                                isClearable
                                                isSearchable
                                                placeholder="Select Vendor"
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: skin === 'dark' ? '#343a40' : '#fff',
                                                        borderColor: state.isFocused ? '#86b7fe' : updateErrors.vendor ? '#dc3545' : '#ced4da',
                                                        color: skin === 'dark' ? '#fff' : '#212529',
                                                        borderWidth: '1px',
                                                        borderRadius: '0.375rem',
                                                        minHeight: '38px',
                                                        transition: 'all 0.15s ease-in-out',
                                                        boxShadow: state.isFocused ?
                                                            (updateErrors.vendor ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : '0 0 0 0.2rem rgba(13, 110, 253, 0.25)')
                                                            : 'none',
                                                        '&:hover': {
                                                            borderColor: state.isFocused ? '#86b7fe' : updateErrors.vendor ? '#dc3545' : '#adb5bd'
                                                        },
                                                        fontFamily: 'inherit',
                                                        fontWeight: '400'
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        backgroundColor: skin === 'dark' ? '#343a40' : '#fff',
                                                        borderRadius: '0.375rem',
                                                        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                                                        border: skin === 'dark' ? '1px solid #495057' : '1px solid #dee2e6',
                                                        marginTop: '2px',
                                                        zIndex: 9999
                                                    }),
                                                    menuList: (base) => ({
                                                        ...base,
                                                        padding: '0',
                                                        borderRadius: '0.375rem'
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.isSelected
                                                            ? (skin === 'dark' ? '#0d6efd' : '#0d6efd')
                                                            : state.isFocused
                                                                ? (skin === 'dark' ? '#495057' : '#f8f9fa')
                                                                : (skin === 'dark' ? '#343a40' : '#fff'),
                                                        color: state.isSelected ? '#fff' : (skin === 'dark' ? '#fff' : '#212529'),
                                                        padding: '8px 12px',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.15s ease-in-out',
                                                        '&:active': {
                                                            backgroundColor: skin === 'dark' ? '#495057' : '#e9ecef'
                                                        }
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#fff' : '#212529',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400',
                                                        marginLeft: '2px'
                                                    }),
                                                    input: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#fff' : '#212529',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400'
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400'
                                                    }),
                                                    clearIndicator: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        padding: '4px',
                                                        cursor: 'pointer',
                                                        '&:hover': {
                                                            color: skin === 'dark' ? '#fff' : '#212529'
                                                        }
                                                    }),
                                                    dropdownIndicator: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        padding: '4px',
                                                        cursor: 'pointer',
                                                        '&:hover': {
                                                            color: skin === 'dark' ? '#fff' : '#212529'
                                                        }
                                                    }),
                                                    indicatorSeparator: (base) => ({
                                                        ...base,
                                                        backgroundColor: skin === 'dark' ? '#495057' : '#dee2e6'
                                                    }),
                                                    loadingIndicator: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d'
                                                    }),
                                                    noOptionsMessage: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400'
                                                    }),
                                                    loadingMessage: (base) => ({
                                                        ...base,
                                                        color: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '400'
                                                    })
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: '#0d6efd',
                                                        primary25: skin === 'dark' ? '#495057' : '#e9ecef',
                                                        primary50: skin === 'dark' ? '#3d4348' : '#dee2e6',
                                                        primary75: '#0d6efd',
                                                        danger: '#dc3545',
                                                        dangerLight: '#f8d7da',
                                                        neutral0: skin === 'dark' ? '#343a40' : '#fff',
                                                        neutral5: skin === 'dark' ? '#495057' : '#f8f9fa',
                                                        neutral10: skin === 'dark' ? '#495057' : '#e9ecef',
                                                        neutral20: skin === 'dark' ? '#495057' : '#dee2e6',
                                                        neutral30: skin === 'dark' ? '#6c757d' : '#ced4da',
                                                        neutral40: skin === 'dark' ? '#6c757d' : '#adb5bd',
                                                        neutral50: skin === 'dark' ? '#6c757d' : '#6c757d',
                                                        neutral60: skin === 'dark' ? '#adb5bd' : '#495057',
                                                        neutral70: skin === 'dark' ? '#adb5bd' : '#495057',
                                                        neutral80: skin === 'dark' ? '#fff' : '#212529',
                                                        neutral90: skin === 'dark' ? '#fff' : '#212529',
                                                    },
                                                })}
                                            />
                                            {updateErrors.vendor && (
                                                <div className="text-danger small mt-1" style={{ fontSize: '0.875rem', fontWeight: '400' }}>
                                                    {updateErrors.vendor}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3">
                                    <Form.Label className='fw-semibold'>Invoice Number <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="invoiceNo"
                                        value={updateFormData.invoiceNo}
                                        onChange={handleUpdateInputChange}
                                        isInvalid={!!updateErrors.invoiceNo}
                                        placeholder="Enter invoice number"
                                        className={skin === 'dark' ? 'bg-dark text-white border-secondary' : ''}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {updateErrors.invoiceNo}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className='fw-semibold'>Invoice File</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        onChange={handleUpdateFileChange}
                                        isInvalid={!!updateErrors.invoice_file}
                                        className={skin === 'dark' ? 'bg-dark text-white border-secondary' : ''}
                                    />
                                    <Form.Text className="text-muted">
                                        Supported formats: JPG, JPEG, PNG, PDF (Max: 5MB)
                                    </Form.Text>
                                    <Form.Control.Feedback type="invalid">
                                        {updateErrors.invoice_file}
                                    </Form.Control.Feedback>

                                    {/* File Preview */}
                                    {(filePreview || selectedProcurementForUpdate?.invoice_file) && (
                                        <div className="mt-2">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <small className="text-muted">Current file:</small>
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={removeUpdateFile}
                                                    disabled={!updateFormData.invoice_file}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </Button>
                                            </div>

                                            {filePreview ? (
                                                filePreview.startsWith('data:image') ? (
                                                    <div className="mt-1">
                                                        <img
                                                            src={filePreview}
                                                            alt="Invoice preview"
                                                            style={{ maxWidth: '200px', maxHeight: '150px' }}
                                                            className="img-thumbnail"
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="mt-1">
                                                        <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                                                        <span>{updateFormData.invoice_file?.name || 'PDF Document'}</span>
                                                    </div>
                                                )
                                            ) : selectedProcurementForUpdate?.invoice_file ? (
                                                <div className="mt-1">
                                                    <i className="bi bi-file-earmark-text text-primary me-2"></i>
                                                    <span>Existing file attached</span>
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                </Form.Group>

                                {/* Current Information Display */}
                                {selectedProcurementForUpdate && (
                                    <div className="mt-3 p-3 border rounded">
                                        <h6 className="mb-2">Current Information</h6>
                                        <Row>
                                            <Col md={6}>
                                                <small className="text-muted">Outlet:</small>
                                                <div>{selectedProcurementForUpdate.outlet?.name || 'N/A'}</div>
                                            </Col>
                                            <Col md={6}>
                                                <small className="text-muted">Vendor:</small>
                                                <div>{selectedProcurementForUpdate.vendor?.name || 'N/A'}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            </Modal.Body>

                            <Modal.Footer className={skin === 'dark' ? 'bg-dark border-secondary' : ''}>
                                <Button variant="secondary" onClick={handleCloseUpdateModal} disabled={updateLoading}>
                                    Cancel
                                </Button>
                                <Button variant="primary" type="submit" disabled={updateLoading}>
                                    {updateLoading ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className="me-2"
                                            />
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-check-circle me-2"></i>
                                            Update Procurement
                                        </>
                                    )}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>

                    {/* Delete Procurement Modal */}
                    <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this procurement? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleSubmitDelete}>
                                {isDeleteLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Delete Procurement"
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Delete Procurement Items Modal */}
                    <Modal show={openItemDeleteModal} onHide={handleCloseItemDeleteModal} style={{ boxShadow: ' 0 15px 50px rgba(0,0,0,0.35);' }} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this procurement item? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseItemDeleteModal}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleSubmitItemDelete}>
                                {isDeleteItemLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Delete Procurement Item"
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default LocalProcurement